import { jsx as E } from "react/jsx-runtime";
import { offerDefaultErrors as M } from "../../../../pages/checkout/constants/default-errors.mjs";
import { BadRequest as P } from "@systemeio/util";
import D from "../../../../ui-kit/theme-button.mjs";
import { stripeCardBuyOffer as _, confirmPaymentIntent as q } from "../../api/stripe-api.mjs";
import { useStripe as x, useElements as H } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { getStripeCardConfirmHandler as O } from "../utils/get-stripe-card-confirm-handler.mjs";
import { useStore as T } from "../../../../store/index.mjs";
import { twJoin as j } from "tailwind-merge";
function K({
  isFetching: d,
  buttonTitle: u,
  buttonDisabled: p,
  setErrors: r,
  setIsFetching: a,
  preSubmit: y,
  handleBadRequest: w,
  hasErrors: h
}) {
  const { locale: g } = T(), o = x(), n = H(), b = async (S) => {
    if (S.preventDefault(), !(!o || !n))
      try {
        const { error: t } = await n.submit();
        if (t) return;
        const m = y();
        if (!m) return;
        a(!0), r(M);
        const { paymentMethod: i, error: s } = await o.createPaymentMethod({
          elements: n,
          params: {
            billing_details: {
              address: {
                country: null,
                line1: null,
                line2: null,
                city: null,
                state: null,
                postal_code: null
              }
            }
          }
        });
        if (s) {
          r((e) => ({
            ...e,
            common: [...e.common, s.message]
          }));
          return;
        }
        if (!i)
          throw Error("undefined payment method");
        const { redirect: l, intentSecret: f, intentType: C } = await _(
          { ...m, options: { stripePaymentMethodId: i.id } },
          g
        );
        if (!f) return window.location.href = l;
        const B = O(o, C), { error: c } = await B(f, {
          payment_method: i.id
        });
        c ? r((e) => ({ ...e, common: [...e.common, c.message] })) : (await q(), window.location.assign(l));
      } catch (t) {
        if (t instanceof P)
          w(t);
        else
          throw t;
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ E(
    D,
    {
      disabled: p,
      className: j("main-transition-colors", h && "bg-danger focus:bg-danger"),
      onClick: b,
      isFetching: d,
      type: "submit",
      children: u
    }
  );
}
export {
  K as StripeCardPaymentButton
};
